<template>
  <v-container class="pa-0">
    <v-card class="ma-0 ticket-page-card" width="100%" flat>
      <div class="wrapper-ticket">
        <v-row>
          <v-col cols="12" md="4" class="py-4 ticket-list-col">
            <TicketList
              ref="ticketList"
              @isFilterDrawerVisible="isFilterDrawerVisible"
              @isConversationDrawerVisible="isConversationDrawerVisible"
              @openTicketConversation="openTicketConversation"
              :selectedDepartmentIdFilter="selectedDepartmentIdFilter"
              :selectedStatusId="selectedStatus"
              :selectedFromDate="selectedFromDate"
              :selectedToDate="selectedToDate"
              :selectedUserId="selectedUserId"
              :selectedCustomerId="selectedCustomerId"
              :isFiltersApply="isFiltersApply"
              :isFiltersRemove="isFiltersRemove"
              @ticketSelection="ticketSelectionHandler"
              @onSelectTicket="onSelectTicketHandler"
              @createNewTicket="createNewTicketHandler"
              :newTicket="newTicket"
              :closedTicketId="closedTicketId"
              :statusRefreshKey="statusRefreshKey"
              @onToggleTicketSelection="onToggleTicketSelection"
            />
          </v-col>
          <v-col cols="12" md="8" class="py-4">
            <TicketMessage
              :isTicketSelected="isTicketSelected"
              :selectedTicket="selectedTicket"
              :isCreateNewTicket="isCreateNewTicket"
              @addTickets="addTicketsHandler"
              @closeTicket="closeTicket"
              @ticketStatusChanged="onTicketStatusChanged"
              @liveTicketMessage="onLiveTicketMessage"
              @openTicketConversation="openTicketConversation"
              :toggleSelectionTicket="toggleSelectionTicket"
            />
          </v-col>
        </v-row>
      </div>
    </v-card>

    <v-navigation-drawer
      v-if="isSupportAbr"
      v-model="conversationDrawerVisibility"
      fixed
      temporary
      left
      width="820"
      elevation="0"
      class="ticket-conversation-drawer"
    >
      <div class="ticket-conversation-drawer-inner">
        <div class="ticket-conversation-drawer-header">
          <v-card-text class="pa-0">{{ $t("conversations") }}</v-card-text>
          <v-icon style="cursor: pointer" @click="conversationDrawerVisibility = false">
            mdi-close
          </v-icon>
        </div>
        <div class="ticket-conversation-drawer-body">
          <Conversation
            v-if="conversationDrawerVisibility"
            :ref-type="conversationFocusTicketId != null ? 'ticket' : null"
            :ref-id="conversationFocusTicketId"
            :title="conversationFocusTicketTitle"
          />
        </div>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="filterDrawerVisibility"
      absolute
      temporary
      width="350"
      elevation="0"
      class="ticket-drawer"
    >
      <v-container class="pa-0">
        <v-container class="d-flex justify-space-between pa-5">
          <v-card-text class="pa-0">{{ $t("filter") }}</v-card-text>
          <v-icon
            style="cursor: pointer"
            @click="filterDrawerVisibility = !filterDrawerVisibility"
          >
            mdi-close
          </v-icon>
        </v-container>
        <v-list-item class="mb-2">
          <autocomplete
            v-model="department"
            :title="$t('departments')"
            type="departments"
            :value="department"
            class="flex-fill"
            @clear="clearFilters('department')"
          />
        </v-list-item>
        <!-- <v-list-item class="mb-2">
          <autocomplete
            v-model="status"
            :title="$t('status')"
            type="ticketStatus"
            :value="status"
            class="flex-fill"
            @clear="clearFilters('status')"
          />
        </v-list-item> -->
        <v-list-item v-if="isSupportAbr" class="mb-2">
          <FlexibleAutocomplete
            v-model="user"
            title="user"
            type="user"
            :multiple="false"
            :fetchData="fetchUsersApi"
            class="flex-fill"
          />
        </v-list-item>
        <v-list-item v-if="isSupportAbr" class="mb-2">
          <FlexibleAutocomplete
            v-model="customer"
            title="customer"
            type="customer"
            :multiple="false"
            :fetchData="fetchCustomersApi"
            class="flex-fill"
          />
        </v-list-item>
        <v-card-text class="pb-0 pt-5 text-body-1">{{ $t("choose date") }}</v-card-text>
        <v-list-item class="mb-2">
          <template>
            <v-text-field
              id="fromDate"
              v-model="selectedFromDate"
              :label="$t('fromDate')"
              append-icon="mdi-calendar"
              outlined
              dense
              clearable
            />
            <date-picker
              v-model="selectedFromDate"
              element="fromDate"
              format="jYYYY/jMM/jDD"
            />
          </template>
        </v-list-item>
        <v-list-item class="mb-2">
          <v-text-field
            id="toDate"
            v-model="selectedToDate"
            :label="$t('toDate')"
            append-icon="mdi-calendar"
            outlined
            dense
            clearable
          />
          <date-picker v-model="selectedToDate" element="toDate" format="jYYYY/jMM/jDD" />
        </v-list-item>
      </v-container>

      <v-container class="d-flex justify-end align-end px-5 gap-2" style="flex-grow: 1">
        <v-btn color="primary" class="flex-fill" @click="applyFilter">
          <span>{{ $t("apply filters") }}</span>
        </v-btn>
        <v-btn outlined class="flex-fill" @click="removeFilter">
          <span>{{ $t("delete filters") }}</span>
        </v-btn>
      </v-container>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import TicketList from "@/views/dashboard/pages/ticket/partial/TicketList.vue";
import TicketMessage from "@/views/dashboard/pages/ticket/partial/TicketMessage.vue";
import FlexibleAutocomplete from "@/views/dashboard/components/general/patial/FlexibleAutocomplete.vue";
import Conversation from "@/views/dashboard/components/general/conversation/Conversation.vue";

export default {
  name: "App",
  data() {
    return {
      filterDrawerVisibility: false,
      conversationDrawerVisibility: false,
      conversationFocusTicketId: null,
      conversationFocusTicketTitle: "",
      status: null,
      departments: null,
      selectedStatus: null,
      isFiltersApply: false,
      isFiltersRemove: false,
      isTicketSelected: false,
      selectedTicket: null,
      isCreateNewTicket: false,
      newTicket: null,
      selectedFromDate: null,
      selectedToDate: null,
      closedTicketId: null,
      statusRefreshKey: 0,
      department: null,
      selectedDepartmentIdFilter: null,
      user: null,
      customer: null,
      selectedUserId: null,
      selectedCustomerId: null,
      toggleSelectionTicket: false,
    };
  },
  components: {
    TicketList,
    TicketMessage,
    FlexibleAutocomplete,
    Conversation,
  },
  computed: {
    selectedTicketId() {
      return this.selectedTicket && this.selectedTicket.id != null
        ? this.selectedTicket.id
        : null;
    },
    isSupportAbr() {
      try {
        const token = JSON.parse(localStorage.getItem("token") || "{}");
        return (
          Number(
            token &&
              token.init &&
              token.init.appBarsOpacity &&
              token.init.appBarsOpacity.abr
          ) === 83
        );
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    mapAutocompleteItems(list) {
      return (Array.isArray(list) ? list : []).map(function (item) {
        if (!item || item.name) {
          return item;
        }
        const name =
          item.value ||
          item.name ||
          [item.firstname, item.lastname].filter(Boolean).join(" ").trim() ||
          item.title ||
          item.full_name ||
          item.fullname ||
          String(item.id);
        return Object.assign({}, item, { name });
      });
    },
    resolveList(response) {
      let list = response && response.data ? response.data : [];
      if (!Array.isArray(list) && list && Array.isArray(list.data)) {
        list = list.data;
      }
      return Array.isArray(list) ? list : [];
    },
    resolveSelectedId(val) {
      const item = Array.isArray(val) ? val[0] : val;
      return item && item.abr != null ? item.abr : null;
    },
    resolveSelectedValue(val) {
      const item = Array.isArray(val) ? val[0] : val;
      return item && item.id != null ? item.id : null;
    },
    fetchUsersApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
      };
      return app.$axios
        .get(app.$endpoint + "reports/get-main-users", { params })
        .then(function (response) {
          let list = app.resolveList(response);
          return {
            items: app.mapAutocompleteItems(list),
            hasMore: list.length === 10,
          };
        });
    },
    fetchCustomersApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
      };
      return app.$axios
        .get(app.$endpoint + "reports/customer-abr-configs", { params })
        .then(function (response) {
          let list = app.resolveList(response);
          return {
            items: app.mapAutocompleteItems(list),
            hasMore: list.length === 10,
          };
        });
    },
    isFilterDrawerVisible() {
      this.filterDrawerVisibility = !this.filterDrawerVisibility;
    },
    isConversationDrawerVisible() {
      if (!this.isSupportAbr) {
        return;
      }
      // Global entry: show all conversations, do not focus selected ticket
      this.conversationFocusTicketId = null;
      this.conversationFocusTicketTitle = "";
      this.conversationDrawerVisibility = !this.conversationDrawerVisibility;
    },
    openTicketConversation(payload) {
      if (!this.isSupportAbr) {
        return;
      }
      const ticket = payload || {};
      // Per-ticket entry: open/create chat for this ticket only
      this.conversationFocusTicketId =
        ticket.id != null ? ticket.id : this.selectedTicketId;
      this.conversationFocusTicketTitle =
        ticket.title || (this.selectedTicket && this.selectedTicket.title) || "";
      this.conversationDrawerVisibility = true;
    },
    applyFilter() {
      this.isFiltersApply = !this.isFiltersApply;
      this.filterDrawerVisibility = false;
    },
    removeFilter() {
      this.isFiltersRemove = !this.isFiltersRemove;
      this.department = null;
      this.selectedDepartmentIdFilter = null;
      this.status = null;
      this.selectedStatus = null;
      this.user = null;
      this.selectedUserId = null;
      this.customer = null;
      this.selectedCustomerId = null;
      this.selectedFromDate = null;
      this.selectedToDate = null;
      this.filterDrawerVisibility = false;
    },
    ticketSelectionHandler(value) {
      this.isTicketSelected = value;
    },
    onToggleTicketSelection(val) {
      this.toggleSelectionTicket = val;
    },
    onSelectTicketHandler(value) {
      this.selectedTicket = value;
    },
    createNewTicketHandler() {
      this.selectedTicket = null;
      this.isCreateNewTicket = !this.isCreateNewTicket;
    },
    addTicketsHandler(value) {
      this.newTicket = value;
    },
    onTicketStatusChanged() {
      this.statusRefreshKey += 1;
    },
    onLiveTicketMessage(payload) {
      if (this.$refs.ticketList && this.$refs.ticketList.prependLiveTicket) {
        this.$refs.ticketList.prependLiveTicket(payload);
      }
    },
    closeTicket(value) {
      this.closedTicketId = value;
    },
    clearFilters(value) {
      if (value == "department") {
        this.selectedDepartmentIdFilter = null;
      }
      if (value == "status") {
        this.selectedStatus = null;
      }
      if (value == "user") {
        this.selectedUserId = null;
      }
      if (value == "customer") {
        this.selectedCustomerId = null;
      }
    },
  },
  watch: {
    department(val) {
      if (val) {
        this.selectedDepartmentIdFilter = val.id;
      }
    },
    status(val) {
      if (val) {
        this.selectedStatus = val.id;
      }
    },
    user(val) {
      this.selectedUserId = this.resolveSelectedValue(val);
    },
    customer(val) {
      this.selectedCustomerId = this.resolveSelectedId(val);
    },
  },
};
</script>

<style>
.ticket-page-card {
  height: 83vh;
  overflow: visible;
}
.wrapper-ticket {
  height: 100%;
  padding: 16px;
  background: radial-gradient(
      1200px 560px at 100% 0%,
      rgba(150, 165, 185, 0.0025),
      transparent 85%
    ),
    radial-gradient(
      1000px 520px at 0% 100%,
      rgba(155, 175, 195, 0.0015),
      transparent 80%
    ),
    #fcfcfd;
}
.ticket-conversation-drawer,
.ticket-conversation-drawer .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
.ticket-conversation-drawer.v-navigation-drawer {
  box-shadow: none !important;
  z-index: 10 !important;
  height: 100% !important;
  top: 0 !important;
  max-height: 100% !important;
  border-right: 1px solid #e5e5e5;
}
.ticket-conversation-drawer-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.ticket-conversation-drawer-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.ticket-conversation-drawer-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.wrapper-ticket > .row {
  height: 100%;
}
.wrapper-ticket .ticket-list-col {
  height: 100%;
  display: flex;
  box-shadow: -8px 0 12px -8px rgba(15, 23, 42, 0.22);
}
.theme--dark .wrapper-ticket .ticket-list-col {
  box-shadow: -8px 0 14px -8px rgba(0, 0, 0, 0.55);
}
@media (max-width: 959px) {
  .ticket-page-card {
    height: auto;
    min-height: 100%;
  }
  .wrapper-ticket {
    height: auto;
    overflow: visible;
  }
  .wrapper-ticket > .row {
    height: auto;
  }
  .wrapper-ticket .ticket-list-col {
    height: auto;
    box-shadow: none;
  }
}
.wrapper-ticket .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
  margin: 0;
  padding: 12px;
  border-radius: 12px;
  width: 100%;
  /* border: 1px solid #999999; */
  height: 64px;
}
.wrapper-ticket .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.ticket-drawer,
.ticket-drawer .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
.ticket-drawer.v-navigation-drawer {
  box-shadow: none !important;
  z-index: 2 !important;
}
/** global for ticket **/
.v-card .v-divider {
  border-color: rgba(192, 192, 192, 0.765) !important;
}
.v-divider--vertical.v-divider--inset {
  margin-top: 0 !important;
}
.v-card--link:before {
  background: transparent !important;
}
.v-menu__content::-webkit-scrollbar {
  width: 4.5px;
  background-color: silver !important;
}
.v-menu__content::-webkit-scrollbar-track {
  background-color: rgba(189, 189, 189, 0.769);
  border: none !important;
}
.v-menu__content::-webkit-scrollbar-thumb {
  background-color: rgba(105, 101, 101, 0.767) !important;
  border: none !important;
}
/* .v-navigation-drawer .v-icon.v-icon {
    font-size: 20px !important;
} */
</style>
